import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.667 4.667A.667.667 0 0 0 6 5.333v5.334a.667.667 0 1 0 1.333 0V5.333a.667.667 0 0 0-.666-.666M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333m0 12A5.333 5.333 0 1 1 8 2.668a5.333 5.333 0 0 1 0 10.665m1.333-8.666a.667.667 0 0 0-.666.666v5.334a.667.667 0 1 0 1.333 0V5.333a.667.667 0 0 0-.667-.666"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })